import * as React from "react"
import Button from "@mui/material/Button"
import ButtonGroup from "@mui/material/ButtonGroup"
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown"
import ClickAwayListener from "@mui/material/ClickAwayListener"
import Grow from "@mui/material/Grow"
import Paper from "@mui/material/Paper"
import Popper from "@mui/material/Popper"
import MenuItem from "@mui/material/MenuItem"
import MenuList from "@mui/material/MenuList"
import { IconButton } from "@mui/material"
import DownloadIcon from "@mui/icons-material/Download"
import { useDispatch, useSelector } from "react-redux"
import { setExportPdfCsvSelection } from "../../redux/slices/appSlice"
import { useEffect } from "react"

const options = ["PDF", "CSV"]

export default function ExportPdfCsv({ handleDownload, styleProps }: any) {
  const dispatch = useDispatch()
  const selectionPdfCsv = useSelector(
    (state: any) => state.app.exportPdfCsvSelection,
  )
  const [open, setOpen] = React.useState(false)
  const anchorRef = React.useRef<HTMLDivElement>(null)
  const [selectedIndex, setSelectedIndex] = React.useState(
    selectionPdfCsv === "PDF" ? 0 : 1,
  )
  const [downloadRequested, setDownloadRequested] = React.useState(false)

  const handleDownloadPdf = () => {
    handleDownload()
  }

  const handleClick = () => {
    setDownloadRequested(true)
  }

  const handleMenuItemClick = (
    event: React.MouseEvent<HTMLLIElement, MouseEvent> | any,
    index: number,
  ) => {
    setSelectedIndex(index)
    dispatch(setExportPdfCsvSelection(event.target?.innerText))
    setOpen(false)
    handleClick()
  }

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen)
  }

  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return
    }
    setOpen(false)
  }

  useEffect(() => {
    if (downloadRequested) {
      handleDownload()
      setDownloadRequested(false)
    }
  }, [selectionPdfCsv])

  return (
    <React.Fragment>
      <ButtonGroup
        ref={anchorRef}
        aria-label="Button group with a nested menu"
        sx={{
          height: "40px",
          backgroundColor: "#1A428A",
          color: "white",
          "&:hover": { backgroundColor: "#1A428A" },
          ...styleProps,
        }}
      >
        <Button
          onClick={handleDownloadPdf}
          sx={{
            color: "#FFFFFF",
          }}
        >
          <IconButton
            disableRipple
            sx={{
              color: "#FFFFFF",
              padding: 0,
              fontSize: 14,
              ml: "-10px",
              mr: "10px",
            }}
          >
            <DownloadIcon />
          </IconButton>
          {options[selectedIndex]}
        </Button>
        <Button
          sx={{
            minWidth: "10px !important",
            borderLeft: "1px solid white",
            padding: 0,
            color: "#FFFFFF",
          }}
          size="small"
          aria-controls={open ? "split-button-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-label="select merge strategy"
          aria-haspopup="menu"
          onClick={handleToggle}
        >
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>
      <Popper
        sx={{
          zIndex: 1,
        }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {options.map((option, index) => (
                    <MenuItem
                      key={option}
                      disabled={index === 2}
                      selected={index === selectedIndex}
                      onClick={(event) => handleMenuItemClick(event, index)}
                    >
                      {option}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </React.Fragment>
  )
}
